import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { CustomCardWrapper, CustomText } from "@corporate-trip-planner-fe/ui-styles";
import { TripDetailsWrapper, TripImageWrapper } from "../trip-card/trip-card.style";
function DestinationCard(_a) {
    var destination = _a.destination;
    return (_jsxs(CustomCardWrapper, { "data-destination-id": destination.id, padding: "0", background: "", children: [_jsx(TripImageWrapper, { children: _jsx("img", { src: destination.image, alt: "".concat(destination.title, " - one of the popular trending destinations") }) }), _jsx(TripDetailsWrapper, { children: _jsx(CustomText, { "$color": "#333", "$fontSize": "14px", "$fontWeight": "bold", children: destination.title }) })] }));
}
export default DestinationCard;
